import React from "react";
import logo from "../../../assets/images/logo-b_w.png";

const PrescriptionFooterForReport = ({ footerData }: { footerData: any; }) => {

  const footerContainer = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: "20px",
    fontSize: "12px",
  };

  const logoStyle = {
    width: "100%",
    objectFit: "contain",
  };

  return (
    <>
      <div style={footerContainer}>
        <div
          style={{
            marginTop: "40px",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <span
            style={{
              fontSize: "7px",
              color: "gray",
              marginLeft: "46px",
              marginBottom: "-5px",
            }}
          >
            Powered by
          </span>
          <img
            src={logo}
            alt="Footer Logo"
            style={{ ...logoStyle, width: "100px", height: '20px' }}
          />
        </div>
        {footerData?.businessInformation?.footerEnable && (
          <div
            style={{
              display: "flex",
              alignItems: "flex-start",
            }}
          >
            {footerData?.businessInformation?.stampServerImage && (
              <div style={{ width: "60px", height: "60px" }}>
                <img
                  src={`data:image/png;base64,${footerData?.businessInformation?.stampServerImage}`}
                  alt="Stamp"
                  style={logoStyle}
                />
              </div>
            )}

            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                textAlign: "center",
              }}
            >
              {footerData?.businessInformation?.signatureServerImage && (
                <div style={{ width: "100px", height: "40px" }}>
                  <img
                    src={`data:image/png;base64,${footerData?.businessInformation?.signatureServerImage}`}
                    alt="signature"
                    style={logoStyle}
                  />
                </div>
              )}

              <div
                style={{
                  fontSize: "13px",
                  fontWeight: "bold",
                  marginTop: "5px",
                }}
              >
                {footerData?.opdDetails?.consultingDoctorName}
              </div>

              <div style={{ fontSize: "11px", color: "#555" }}>
                ({footerData?.opdDetails?.qualification})
              </div>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default PrescriptionFooterForReport;
